import { render, staticRenderFns } from "./Confirmations.vue?vue&type=template&id=1f1e5fa4&scoped=true&"
import script from "./Confirmations.vue?vue&type=script&lang=js&"
export * from "./Confirmations.vue?vue&type=script&lang=js&"
import style0 from "./Confirmations.vue?vue&type=style&index=0&id=1f1e5fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e5fa4",
  null
  
)

export default component.exports